import { render, staticRenderFns } from "./popGoodsInfo.vue?vue&type=template&id=127a9c7c"
import script from "./popGoodsInfo.vue?vue&type=script&lang=js"
export * from "./popGoodsInfo.vue?vue&type=script&lang=js"
import style0 from "./popGoodsInfo.vue?vue&type=style&index=0&id=127a9c7c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127a9c7c')) {
      api.createRecord('127a9c7c', component.options)
    } else {
      api.reload('127a9c7c', component.options)
    }
    module.hot.accept("./popGoodsInfo.vue?vue&type=template&id=127a9c7c", function () {
      api.rerender('127a9c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/saleOrder/components/popGoodsInfo/popGoodsInfo.vue"
export default component.exports